import { useMemo, useState } from "react";
import SettingsContext, { SettingsType } from "./settingsContext";

const SettingsProvider = (props: { children: React.ReactNode }) => {
  const { children } = props;

  const settingsString = localStorage.getItem("settings");

  let InitialSettingsState = {
    planData: true,
    foreCastData: false,
  };

  if (settingsString !== null) {
    const { planData, foreCastData }: SettingsType = JSON.parse(settingsString);

    InitialSettingsState = {
      planData,
      foreCastData,
    };
  }

  const [settingsState, settingsSetState] =
    useState<SettingsType>(InitialSettingsState);

  const stateValue = useMemo(
    () => [{ settingsState, settingsSetState }],
    [settingsState, settingsSetState]
  );

  return (
    <SettingsContext.Provider value={stateValue}>
      {children}
    </SettingsContext.Provider>
  );
};

export default SettingsProvider;
